import { connect } from 'react-redux';

import { BucketState } from 'src/types/state';

import FilteredFileListItem from '../components/file-filter/list-item';
import { getFilterQuery } from '../reducers/section';

const mapStateToProps = (state: BucketState) => ({
  query: getFilterQuery(state),
});

export default connect(mapStateToProps)(FilteredFileListItem);
